import { useCallback, useMemo } from 'react'
import {
  textePublic,
  traduireTexteConnu,
  LOCALE_INTL,
  type ClefTextePublic,
  type ArgumentsTextePublic,
} from '@tb/shared'
import { useLangueInterface } from './langue-interface'
/** Les clés et paramètres absents sont refusés par TypeScript ; les pluriels
 * suivent la langue, notamment zéro en français, allemand et anglais. */
export function useTextePublic() {
  const langue = useLangueInterface()
  const traduire = useCallback(
    <T extends ClefTextePublic>(clef: T, ...args: ArgumentsTextePublic<T>) =>
      textePublic(clef, langue, ...args),
    [langue],
  )
  const nombre = useCallback(
    <T extends ClefTextePublic>(
      quantite: number,
      singulier: T,
      pluriel: T,
      ...args: ArgumentsTextePublic<T>
    ) =>
      textePublic(
        new Intl.PluralRules(LOCALE_INTL[langue]).select(quantite) === 'one' ? singulier : pluriel,
        langue,
        ...args,
      ),
    [langue],
  )
  const connu = useCallback((texte: string) => traduireTexteConnu(texte, langue), [langue])
  return useMemo(
    () => Object.assign(traduire, { nombre, langue, connu }),
    [traduire, nombre, langue, connu],
  )
}
